import React from 'react';
import { FormField } from '../../../../components/FormField';
import { FormRow } from '../../../../components/FormRow';

interface PromotionProjectInfoProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export const PromotionProjectInfo: React.FC<PromotionProjectInfoProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900 dark:text-white">Informations du projet</h4>

      <FormRow>
        <FormField label="Nom de la résidence">
          <input
            type="text"
            name="residence_name"
            value={property?.residence_name || formData.residence_name || ''}
            onChange={handleInputChange}
            placeholder="Ex: Résidence Les Jardins de Hydra"
          />
        </FormField>

        <FormField label="Numéro d'agrément promoteur">
          <input
            type="text"
            name="promoter_agreement"
            value={property?.promoter_agreement || formData.promoter_agreement || ''}
            onChange={handleInputChange}
            placeholder="Ex: AGR-2024-001"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField label="Statut du permis de construire">
          <select
            name="building_permit_status"
            value={property?.building_permit_status || formData.building_permit_status || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            <option value="accordé">Accordé</option>
            <option value="en cours">En cours</option>
            <option value="non déposé">Non déposé</option>
          </select>
        </FormField>

        <FormField label="Architecte / Bureau d'études">
          <input
            type="text"
            name="architect_name"
            value={property?.architect_name || formData.architect_name || ''}
            onChange={handleInputChange}
            placeholder="Nom de l'architecte"
          />
        </FormField>
      </FormRow>
    </div>
  );
};
